import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const NAV_LINKS = [
  { href: '#about',     label: 'À propos' },
  { href: '#services',  label: 'Services' },
  { href: '#urgences',  label: 'Urgences' },
  { href: '#galerie',  label: 'Galerie' },
  { href: '#zone',      label: "Zone d'intervention" },
  { href: '#garanties', label: 'Garanties' },
  { href: '#temoignages', label: 'Témoignages' },
  { href: '#faq',       label: 'FAQ' },
  { href: '#contact',   label: 'Contact' },
];

export default function Navbar() {
  const [active, setActive]     = useState('');
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isHome   = location.pathname === '/';

  // scrolled state: simple scroll listener (no layout read)
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Active section: IntersectionObserver (zero forced reflow)
  useEffect(() => {
    if (!isHome) return;
    const obs = new IntersectionObserver(
      entries => {
        entries.forEach(e => { if (e.isIntersecting) setActive(e.target.id); });
      },
      { rootMargin: '-40% 0px -55% 0px', threshold: 0 }
    );
    const sections = document.querySelectorAll('section[id]');
    sections.forEach(s => obs.observe(s));
    return () => obs.disconnect();
  }, [isHome]);

  return (
    <>
      {/* Barre urgence — shimmer GPU-composé via transform */}
      <div className="urgent-bar">
        🚨 Urgence nuisibles 7j/7 — Nids de guêpes, frelons, punaises de lit &nbsp;|&nbsp;
        <a href="tel:0624314434">Appeler maintenant : 06 24 31 44 34</a>
      </div>

      <nav className={`navbar${scrolled ? ' scrolled' : ''}`}>
        <Link to="/" className="nav-brand">
          <div className="nav-logo-mark">
            <picture style={{ display: 'block', width: '100%', height: '100%' }}>
              <source srcSet={`${process.env.PUBLIC_URL}/assets/img/logo.webp`} type="image/webp" />
              <img
                src={`${process.env.PUBLIC_URL}/assets/img/logo-small.png`}
                alt="Logo SDN – Savoie Dauphiné Nuisibles"
                width="60"
                height="60"
                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
              />
            </picture>
          </div>
          <div>
            <div className="nav-title">
              <span className="s">S</span><span className="d">D</span><span className="n">N</span>
            </div>
            <div className="nav-subtitle">Savoie Dauphiné Nuisibles</div>
          </div>
        </Link>

        <ul className={`nav-links${menuOpen ? ' open' : ''}`}>
          {NAV_LINKS.map(({ href, label }) => (
            <li key={href}>
              <Link
                to={`/${href}`}
                className={active === href.slice(1) ? 'active' : ''}
                onClick={() => setMenuOpen(false)}
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>

        <div className="nav-actions">
          <a href="tel:0624314434" className="nav-phone">
            <span>📞</span>
            <div>
              <strong>06 24 31 44 34</strong>
              <small>Urgences 7j/7</small>
            </div>
          </a>
          <Link to="/#contact" className="btn-nav">Devis gratuit</Link>
          <button className="burger" onClick={() => setMenuOpen(o => !o)} aria-label="Menu">
            <span /><span /><span />
          </button>
        </div>
      </nav>
    </>
  );
}
